import Vue from 'vue';
import Antd from 'ant-design-vue';
import moment from 'moment';
import 'ant-design-vue/dist/antd.css';
import App from './App.vue';
import router from './router';
import store from "./store";
import "./assets/scss/global.scss";
import VueMeta from 'vue-meta'

Vue.use(VueMeta)
Vue.use(Antd);
Vue.prototype.$moment = moment;
Vue.config.productionTip = false;
export const bus = new Vue();

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
